export default __webpack_public_path__ + "static/media/radioButtonPartial.50b063c6.svg";